import {
  HtmlContent,
  ImagesContent,
  InspectorContent,
  SlideshowContent,
  VideosContent,
  PuzzleContent,
  PhoneContent,
  SubwayContent
} from '../../types'

export enum ContentTypeEnum {
  Video = 'video',
  Images = 'images',
  Slideshow = 'slideshow',
  Inspector = 'inspector',
  Html = 'html',
  Puzzle = 'puzzle',
  Phone = 'phone',
  Subway = 'subway'
}

export type ContentType = `${ContentTypeEnum}`

export type Content =
  | HtmlContent
  | ImagesContent
  | VideosContent
  | SlideshowContent
  | InspectorContent
  | PuzzleContent
  | PhoneContent
  | SubwayContent

export interface BaseContent {
  type: ContentType
  darkOverlay?: boolean
  script?: boolean
}
